import { useLayoutEffect, useRef } from "react";
import ReactDOM from "react-dom";
import classes from "./Background.module.css";

// 背景组件，添加该组件后，背景会自动挂载到Body下
export default function Background() {
    const canvasElement = useRef();

    // 初始化开始绘制粒子
    useLayoutEffect(() => {
        const speed = 1;
        const lineWidth = 0.4;
        const circleSize = 0.7;
        var cxtElementNode = canvasElement.current;
        cxtElementNode.width = window.innerWidth;
        cxtElementNode.height = window.innerHeight;
        var ctx = cxtElementNode.getContext("2d");
        var parcitleNum = 200;
        var randomPosition = [];
        ctx.fillStyle = 'rgba(255,255,255,0)';
        ctx.fillRect(0, 0, cxtElementNode.width, cxtElementNode.height);
        // 设置+调用画球函数
        for (var i = 0; i < parcitleNum; i++) {
            randomPosition[i] = {};
            randomPosition[i].Size = (2 + (Math.random() * 2)) * circleSize;
            randomPosition[i].color = "#B7B7BE";
            randomPosition[i].X = Math.random() * cxtElementNode.width;
            randomPosition[i].Y = Math.random() * cxtElementNode.height;
            randomPosition[i].randomX = (Math.random() * -1 + Math.random() * 1) * speed;
            randomPosition[i].randomY = (Math.random() * -1 + Math.random() * 1) * speed;
            createParcitle(randomPosition[i].X, randomPosition[i].Y);
        }
        // 画和移动球
        function parcitleDynamic() {
            ctx.fillStyle = 'rgba(255,255,255,0)';
            ctx.clearRect(0, 0, cxtElementNode.width, cxtElementNode.height);
            for (var i = 0; i < parcitleNum; i++) {
                if (randomPosition[i].X < 0 || randomPosition[i].X > cxtElementNode.width) {
                    randomPosition[i].randomX = -randomPosition[i].randomX;
                }
                if (randomPosition[i].Y < 0 || randomPosition[i].Y > cxtElementNode.height) {
                    randomPosition[i].randomY = -randomPosition[i].randomY;
                }
                randomPosition[i].X += randomPosition[i].randomX;
                randomPosition[i].Y += randomPosition[i].randomY;
                createParcitle(randomPosition[i].X, randomPosition[i].Y, randomPosition[i].Size, randomPosition[i].color);
            }
        }

        // 创建圆
        function createParcitle(randomX, randomY, randomSize, randomColor) {
            ctx.beginPath();
            ctx.fillStyle = randomColor;
            ctx.arc(randomX, randomY, randomSize, 0, 6.3, false);
            ctx.fill();
            ctx.closePath();
        }

        function drawLine() {
            // 先画圆
            parcitleDynamic();
            // 判断距离是否连线
            for (var i = 0; i < parcitleNum; i++) {
                for (var h = 0; h < parcitleNum; h++) {
                    if (i != h) {
                        if (Math.sqrt(Math.pow((randomPosition[i].X - randomPosition[h].X), 2) + Math.pow((randomPosition[i].Y - randomPosition[h].Y), 2)) < 120) {
                            ctx.beginPath();
                            ctx.moveTo(randomPosition[i].X, randomPosition[i].Y);
                            ctx.lineTo(randomPosition[h].X, randomPosition[h].Y);

                            ctx.strokeStyle = "#9494BE";
                            ctx.globalAlpha = 1;
                            ctx.lineWidth = (0.3 + randomPosition[i].Size * 0.12) * lineWidth;
                            ctx.stroke();
                        }
                    }
                }
            }
            requestAnimationFrame(drawLine);
        }
        drawLine();

        cxtElementNode.onmousemove = function (e) {
            var ex = e.offsetX;
            var ey = e.offsetY;
            for (var i = 0; i < parcitleNum; i++) {
                if (Math.sqrt(Math.pow((randomPosition[i].X - ex), 2) + Math.pow((randomPosition[i].Y - ey), 2)) < 150) {
                    ctx.beginPath();
                    ctx.moveTo(randomPosition[i].X, randomPosition[i].Y);
                    ctx.lineTo(ex, ey);

                    ctx.strokeStyle = "#9494BE";
                    ctx.globalAlpha = 1;
                    ctx.lineWidth = (0.3 + randomPosition[i].Size * 0.12) * lineWidth;
                    ctx.stroke();
                }
            }
        }
    }, []);

    // 挂载到body下
    return ReactDOM.createPortal((
        <>
            {/** 粒子效果 */}
            <div className={classes.canvasContainer}>
                <canvas ref={canvasElement} width="5000" height="3000"></canvas>
            </div>
            {/** 背景图片 */}
            <div className={classes.backgroundImageContainer}>
                <img class={classes.backgroundImage} src="/background.jpg" alt="" />
            </div>
        </>
    ), document.body);
}